import React from "react";

function Proposal() {
  return (
    <div>
      <h2>Proposal</h2>
      <p>Gestión de proposal en proceso.</p>
    </div>
  );
}

export default Proposal;
